import type { RouteObject } from "react-router-dom";

import { ChaptersPage } from "./pages/ChaptersPage";
import { GalleryPage } from "./pages/GalleryPage";
import { HomePage } from "./pages/HomePage";
import { LiveViewPage } from "./pages/LiveViewPage";
import { WhatsNewPage } from "./pages/WhatsNewPage";
import "./navigate.css";

/**
 * F03 web_navigate: the home, the family navigator, the live view with the replay slider, the gallery and
 * what's new (BUILD-PLAN 2.11.2), and the chapters index (COMPLETION-CONTRACTS, CP-17). Who may open each screen is in `app/screens.ts`.
 */
export const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/live", element: <LiveViewPage mode="live" /> },
  { path: "/navigate", element: <LiveViewPage mode="navigate" /> },
  { path: "/gallery", element: <GalleryPage /> },
  { path: "/whats-new", element: <WhatsNewPage /> },
  // The index of the specification chapters (CP-17). One chapter's editor, `/chapters/:key`, is the item module's.
  { path: "/chapters", element: <ChaptersPage /> },
];
